import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../components/ui/Button";
import {
  createCmsService,
  getCmsService,
} from "redux/services/general_service";
import ReturnPolicyDisplay from "./components/AboutUsDisplay";
import ReturnPolicyModal from "./components/AboutUsModal";

import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const AboutUsManagment = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { cms } = useSelector((state) => state.general);

  const [showModal, setShowModal] = useState(false);
  const [editingPolicy, setEditingPolicy] = useState(null);

  useEffect(() => {
    dispatch(getCmsService());
  }, [dispatch]);

  // حفظ التعديلات
  const handleSave = (policyData) => {
    // هنا ممكن تعمل dispatch لإنشاء أو تعديل السياسة
    console.log("Saved Policy Data:", policyData);
    dispatch(
      createCmsService({
        type: "about_us",
        content: policyData?.content,
      }),
    ).then((response) => {
      console.log(response);
      if (response?.payload?.status == 200) {
        toast.success(t("تم"));
        dispatch(getCmsService());
        setEditingPolicy(null);
        setShowModal(false);
      } else {
        console.log(response);
        Object.values(response.payload.errors)
          .flatMap((errorArray) => errorArray)
          .forEach((error) => toast.warn(error));
      }
    });
  };

  // فتح المودال مع النص الحالي للتعديل

  console.log(cms);
  const termsConditions = Array.isArray(cms)
    ? cms.find((item) => item.type === "about_us")
    : null;

  const handleEdit = () => {
    setEditingPolicy({
      title: "   حول – الياقوت",
      content: termsConditions?.content,
    });
    setShowModal(true);
  };
  return (
    <div className="p-6">
      <div className="flex justify-between mb-6">
        <h1 className="text-2xl font-bold">  حول</h1>
        <div className="flex gap-3">
          <Button onClick={handleEdit}>تعديل قسم حول</Button>
        </div>
      </div>

      {/* عرض سياسة الخصوصية */}
      <ReturnPolicyDisplay privacyPolicy={termsConditions} />

      {/* مودال الإضافة/التعديل */}
      <ReturnPolicyModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        policy={editingPolicy}
        onSave={handleSave}
      />
    </div>
  );
};

export default AboutUsManagment;
